import { render, staticRenderFns } from "./OxSafeButton.vue?vue&type=template&id=5735b4f6&"
import script from "./OxSafeButton.vue?vue&type=script&lang=js&"
export * from "./OxSafeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports